import React, {FC} from 'react'
import {IChatGroupItem} from "../../../../types/chat";
import {useAuth} from "../../../../modules/auth";
import moment from "moment";
import imgBaseUrl from "../../../../utils/imgBaseUrl";

type UserItemProps = {
  data: IChatGroupItem
  selectedUser: IChatGroupItem
}

export const UserItem: FC<UserItemProps> = ({data, selectedUser}) => {
  const {currentUser} = useAuth()

  return (
      <div className="d-flex align-items-center flex-stack py-4">
        <div className="d-flex align-items-center">
          <div className="symbol symbol-45px symbol-circle">
            {data?.image ? <img src={imgBaseUrl(data?.image!)} alt={data?.name}/> :
                <span
                    className={"symbol-label fs-2x fw-semibold text-success bg-light-success"}>{data?.name?.[0]?.toUpperCase()}
          </span>
            }
          </div>
          <div className="ms-3"><span
              className={`fs-6 fw-bolder ${selectedUser?.id === data?.id ? "text-primary" : "text-gray-900"} text-hover-primary mb-2`}>{data?.name}</span>
            <div
                className="fw-bold text-gray-500">
              <p className={"text-truncate m-0"} style={{
                maxWidth: "200px",
              }}>{data?.last_message ? (currentUser?.id === data?.last_message?.id ? "Siz:" : `${data?.last_message?.sender?.first_name} ${data?.last_message?.sender?.last_name}:`) : "Yangi chat"}
                <span
                    className={"fw-lighter"}>{data?.last_message && (data?.last_message?.file && "Fayl" || data?.last_message?.message)}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column align-items-end ms-2">
          <span className={"small text-gray-500"}>{moment(data?.last_message?.updated_at).format("HH:mm")}</span>
          {data?.message_count >= 1 && <span
              className="mb-1 badge badge-sm badge-primary">{data?.message_count}</span>}
        </div>
      </div>
  )
}
